import { addPermissionsToRoute } from '@qsrsoft/myq-core';

const routes = {
  name: 'Labor',
  icon: 'mdi-account-group-outline',
  path: '/reports/labor',
  menuFilters: {
    $and: [
      { countryCode: { $in: ['us', 'ca'] } },
      { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
    ],
  },
  children: [
    {
      path: '/reports/labor/timePunches',
      name: 'Time Punches',
      meta: { id: 'mc-timePunches', permission: 'mtLabor' },
      component: () => import('./TimePunches.vue'),
      ...addPermissionsToRoute(['mtLabor']),
      menuFilters: {
        $and: [
          { countryCode: { $in: ['us', 'ca'] } },
          { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
        ],
      },
    },
    {
      path: '/reports/timhortons/labor/crewTraining',
      name: 'Crew Training',
      component: () => import('./CrewTraining.vue'),
      ...addPermissionsToRoute(['mtLabor']),
    },
    {
      path: '/reports/timhortons/labor/dailyLaborHours',
      name: 'Daily Labor Hours',
      component: () => import('./DailyLaborHours.vue'),
      ...addPermissionsToRoute(['mtLabor']),
    },
    {
      path: '/reports/timhortons/labor/weeklyLaborHours',
      name: 'Weekly Labor Hours',
      component: () => import('./WeeklyLaborHours.vue'),
      ...addPermissionsToRoute(['mtLabor']),
    },
    {
      path: '/reports/timhortons/labor/laborSummary',
      name: 'Labor Summary %',
      component: () => import('./LaborSummary.vue'),
      ...addPermissionsToRoute(['mtLabor']),
    },
    {
      path: '/reports/timhortons/labor/laborSchedules',
      name: 'Labor Schedules',
      component: () => import('../../standard/labor/LaborSchedules.vue'),
      ...addPermissionsToRoute(['mtLabor']),
    },
    {
      path: '/reports/mcd/controlsLabor/laborStatistics',
      name: 'Labor Statistics',
      meta: { id: 'reports-laborStatistics', permission: 'mtLabor' },
      component: () => import('./labor-statistics.vue'),
      ...addPermissionsToRoute(['mtLabor']),
    },
    {
      path: '/reports/mcd/controlsLabor/laborAnalysis',
      name: 'Labor Analysis',
      meta: { id: 'reports-laborAnalysis', permission: 'mtLabor' },
      component: () => import('./labor-analysis.vue'),
      ...addPermissionsToRoute(['mtLabor']),
    },
  ],
};

export default routes;
